import { ParagraphBlock } from './ParagraphBlock'

export const QuoteBlock = ({
    contents,
    messageDate,
}: {
    contents: any[]
    messageDate: Date
}) => (
    <blockquote>
        {contents.map((paragraph, index) => (
            <ParagraphBlock
                key={index}
                contents={paragraph.value}
                messageDate={messageDate}
            />
        ))}
    </blockquote>
)
